export type Breakpoints = 'initial' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
export type ResponsiveValue<T = string> = T | Partial<Record<Breakpoints, T>>

export const extractResponsiveValue = <T>(
  breakpoint: Breakpoints,
  value: ResponsiveValue<T> | undefined,
): T | undefined => {
  if (!value) return undefined
  if (typeof value === 'string') return undefined
  return (value as Record<Breakpoints, T>)[breakpoint]
}

export const extractResponsiveInitialValue = <T>(
  value: ResponsiveValue<T> | undefined,
): T | undefined => {
  if (!value) return undefined
  if (typeof value === 'string') return value
  return (value as Record<Breakpoints, T>).initial
}
